<template>
  <div class="vip-page">
    <van-nav-bar
      :title="$t('vip_details.title')"
      left-arrow
      class="vip-nav"
      @click-left="onBack"
    />

    <div class="vip-hero">
      <div class="detail-card">
        <div class="vip-name">
          <div class="vip-name-main">{{ $t('vip_details.member') }}VIP{{ vipLevel }}</div>
          <div class="name-sub">{{ $t('vip_details.lifetime_member') }}</div>
          <div class="name-sub">{{ profitText }}</div>
        </div>
        <div class="vip-name-img-wrap">
          <img
            src="https://heart-fluttering.vip/img/vdetail.9f7d103f.png"
            alt="vip"
            class="vip-title-img"
          />
        </div>
      </div>
    </div>

    <div class="vip-rights">
      <h2 class="rights-title">{{ $t('vip_details.rights_title') }}</h2>
      <div class="rights-grid">
        <div
          v-for="item in benefitItems"
          :key="item.key"
          class="rights-item"
        >
          <div class="rights-icon">
            <van-icon :name="item.icon" size="22" color="#8b7355" />
          </div>
          <div class="rights-name">{{ $t(item.titleKey) }}</div>
          <div class="rights-desc">{{ $t(item.descKey) }}</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
/** VIP level → profit rate (%) shown on card */
const VIP_PROFIT_RATES = {
  0: '0.00',
  1: '0.60',
  2: '0.80',
  3: '1.00',
  4: '1.20',
  5: '1.50',
  6: '1.80',
  7: '2.00',
  8: '2.50',
  9: '3.00',
  10: '3.50',
};

export default {
  data() {
    return {
      vipLevel: 1,
      benefitItems: [
        {
          key: 'see_more',
          icon: 'friends-o',
          titleKey: 'vip_details.see_more_title',
          descKey: 'vip_details.see_more_desc',
        },
        {
          key: 'save_more',
          icon: 'photo-o',
          titleKey: 'vip_details.save_more_title',
          descKey: 'vip_details.save_more_desc',
        },
        {
          key: 'enjoy_more',
          icon: 'video-o',
          titleKey: 'vip_details.enjoy_more_title',
          descKey: 'vip_details.enjoy_more_desc',
        },
        {
          key: 'consultant',
          icon: 'service-o',
          titleKey: 'vip_details.consultant_title',
          descKey: 'vip_details.consultant_desc',
        },
      ],
    };
  },
  computed: {
    profitRate() {
      const vip = Number(this.vipLevel) || 0;
      if (VIP_PROFIT_RATES[vip] != null) {
        return VIP_PROFIT_RATES[vip];
      }
      return '0.60';
    },
    profitText() {
      return this.$t('vip_details.profit_for_level', { rate: this.profitRate });
    },
  },
  methods: {
    onBack() {
      this.$router.go(-1);
    },
    loadUserInfo() {
      const q = this.$route.query.vip;
      if (q != null && q !== '') {
        const n = Number(q);
        if (Number.isFinite(n) && n >= 0) {
          this.vipLevel = n;
          return;
        }
      }
      if (!localStorage.getItem('token')) {
        return;
      }
      this.$http({
        method: 'get',
        url: 'user_info',
      }).then((res) => {
        if (res.code === 200 && res.data) {
          this.vipLevel = Number(res.data.vip) || 1;
        }
      });
    },
  },
  created() {
    this.loadUserInfo();
  },
};
</script>

<style scoped>
.vip-page {
  min-height: 100vh;
  background: #1a1a1a;
  padding-bottom: 24px;
}

.vip-nav {
  background: #1a1a1a;
}

.vip-nav::v-deep .van-nav-bar__title,
.vip-nav::v-deep .van-icon-arrow-left {
  color: #fff;
}

.vip-nav::v-deep .van-nav-bar__arrow {
  color: #fff;
}

.vip-hero {
  padding: 0;
}

.detail-card {
  width: 100%;
  height: 6.66667rem;
  padding: 1rem 1.66667rem;
  box-sizing: border-box;
  background: linear-gradient(45deg, #fae4be, #f4d28e, #f3d596);
  border-radius: 0.8rem 0.8rem 0 0;
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.vip-name {
  flex: 1;
  min-width: 0;
  color: #3d2f14;
}

.vip-name-main {
  font-size: 1.33333rem;
  font-weight: 700;
  line-height: 1.25;
  margin-bottom: 0.35rem;
}

.name-sub {
  font-size: 0.86667rem;
  line-height: 1.4;
  color: #5c4a28;
}

.name-sub + .name-sub {
  margin-top: 0.2rem;
}

.vip-name-img-wrap {
  flex-shrink: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-left: 0.5rem;
}

.vip-title-img {
  width: 4.66667rem;
  height: 4.66667rem;
  object-fit: contain;
}

.vip-rights {
  margin-top: 0;
  padding: 1.33333rem 1rem 1.5rem;
  background: #fff;
  border-radius: 0;
  min-height: calc(100vh - 12rem);
}

.rights-title {
  margin: 0 0 20px;
  font-size: 18px;
  font-weight: 700;
  color: #111;
}

.rights-grid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 14px;
}

.rights-item {
  background: #fff;
  border: 1px solid #eee;
  border-radius: 12px;
  padding: 18px 14px 16px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.04);
}

.rights-icon {
  width: 44px;
  height: 44px;
  border-radius: 50%;
  background: #f0e6d8;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 12px;
}

.rights-name {
  font-size: 15px;
  font-weight: 700;
  color: #111;
  margin-bottom: 6px;
}

.rights-desc {
  font-size: 12px;
  color: #666;
  line-height: 1.4;
}
</style>
